import {
    AutoCompleteResult,
    AutoCompleteResultProps,
} from 'components/data/AutoCompleteResult';
import { Checkbox } from 'components/forms/Checkbox';
import { forwardRef, ReactNode } from 'react';

export type CheckedAutoCompleteResultProps = AutoCompleteResultProps &
    Readonly<{
        /**
         * If checkbox is currently checked.
         */
        isChecked: boolean;
        /**
         * Callback for when item is selected.
         */
        onResultSelect: () => void;
        /**
         * The label for the checkbox.
         */
        label: ReactNode;
    }>;

export const CheckedAutoCompleteResult = forwardRef<
    HTMLDivElement,
    CheckedAutoCompleteResultProps
>(({ $isHighlighted, isChecked, onResultSelect, label }, ref) => (
    <AutoCompleteResult
        $isHighlighted={$isHighlighted}
        ref={ref}
        onClick={onResultSelect}
    >
        <Checkbox checked={isChecked} onChange={onResultSelect} />
        <div>{label}</div>
    </AutoCompleteResult>
));
